/**
 * Audit API, v1
 * Volá /api/audit se stejným tělem jako /api/calculate.
 */
import { buildValuationRequest } from './valuationCalculator';
import { authHeaders } from '../lib/apiFetch';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export async function runAudit(wizardState) {
  try {
    const body = buildValuationRequest(wizardState);

    // Server pustí audit jen k zaplacené uložené valuaci.
    const id = wizardState.savedValuationId;
    const q = id ? `?valuation_id=${encodeURIComponent(id)}` : '';
    const response = await fetch(`${API_BASE}/api/audit${q}`, {
      method: 'POST',
      headers: await authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Audit API error:', error);
    return { success: false, error: error.message };
  }
}
